exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lock-screen-container[data-v-58005236] {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(204, 204, 204, 0.6);\n    z-index: 1000;\n}\n.lock-screen-wrapper[data-v-58005236] {\n    height: 100%;\n    flex-flow: column nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n}\n", ""]);

// exports
